import { instance } from 'api/internaltools';

export const getMerchantTransactions = (id, transaction_limit, page) => {
  return instance.get(`/merchant/${id}/transactions?limit=${transaction_limit}&page=${page}`);
};

export const getTransactions = (
  transaction_limit,
  page,
  statuses = '',
  searchKey = '',
  is_exclude_test_transactions = false,
  is_fetch_stuck_transactions = false,
  has_risk_alerts = false,
  alert_status = ''
) => {
  let query = `/transactions?limit=${transaction_limit}&page=${page}`;

  if (statuses) {
    query += `&statuses=${statuses}`;
  }

  if (searchKey) {
    query += `&search=${searchKey}`;
  }

  if (is_fetch_stuck_transactions) {
    query += `&fetch_stuck_transactions=${is_fetch_stuck_transactions}`;
  }

  if (is_exclude_test_transactions) {
    query += `&is_exclude_test_transactions=${is_exclude_test_transactions}`;
  }

  if (has_risk_alerts) {
    query += `&has_risk_alerts=${has_risk_alerts}`;
  }

  if (alert_status) {
    query += `&alert_status=${alert_status}`;
  }

  return instance.get(query);
};

export const getPayoutSessionStepLevelProgress = (id) => {
  return instance.get(`/transaction/${id}/progress`);
};

export const retriggerPayoutSessionStepEvent = (payload) => {
  return instance.post('/transaction/event/retrigger', payload);
};

export const getTransactionsForApproval = () => {
  return instance.get('/transactions/approval');
};

export const getTransactionDetails = (id, fetch_alerts = false) => {
  return instance.get(`/transaction-v2/${id}/details?fetch_alerts=${fetch_alerts}`);
};

export const approveTransaction = (payload) => {
  return instance.post('/transaction-v2/approve', payload);
};

export const getUserTransactionLimit = (id) => {
  return instance.get(`/users/${id}/transaction-approval-limit`);
};

export const setUserTransactionLimit = (id, payload) => {
  return instance.post(`/users/${id}/transaction-approval-limit`, payload);
};

export const updateUserTransactionLimit = (id, payload) => {
  return instance.patch(`/users/${id}/transaction-approval-limit`, payload);
};

export const getTransactionsRequests = (
  status,
  transactionType,
  isSettlementTxn = false,
  startDate = '',
  endDate = ''
) => {
  return instance.get(
    `/transactions/requests?policy_evaluation_statuses=${status}&transaction_type=${transactionType}&is_settlement_txn=${isSettlementTxn}&start_date=${startDate}&end_date=${endDate}`
  );
};

export const getDetailedTransactionRequest = (id) => {
  return instance.get(`/transactions/requests/${id}`);
};

export const approveTransactionRequest = (id, payload) => {
  return instance.post(`/transactions/${id}/approve`, payload);
};

export const declineTransactionRequest = (id, payload) => {
  return instance.post(`/transactions/${id}/decline`, payload);
};

export const getPendingCreditTransactions = (status, screening_status = '') => {
  let query = `/credits/pending?status=${status}`;

  if (screening_status) {
    query += `&screening_status=${screening_status}`;
  }

  return instance.get(query);
};

export const approveUnmappedCreditTransaction = (id, payload) => {
  return instance.post(`/unmapped-transactions/${id}/approve`, payload);
};

export const getTransactionScreeningDetails = (id) => {
  return instance.get(`/transactions/${id}/screening-details`);
};

export const handleInReviewCreditTransaction = (id, payload) => {
  return instance.post(`/credits/${id}`, payload);
};

export const refundUnmappedTransaction = (id, payload) => {
  return instance.post(`/unmapped-transaction/${id}/refund`, payload);
};

export const refundCreditTransaction = (id, payload) => {
  return instance.post(`/credit/${id}/refund`, payload);
};

export const getBeneficiariesByMerchantId = (id, payoutMethods = '') => {
  return instance.get(`/merchant/${id}/beneficiaries?payoutMethods=${payoutMethods}`);
};

export const getPayoutPurposes = () => {
  return instance.get('/payout/purposes');
};

export const updatePayoutPurpose = (id, payload) => {
  return instance.patch(`/transaction/${id}/purpose`, payload);
};

export const getDebitTxnsScreeningDetails = (status) => {
  return instance.get(`/transactions/debit/screening-details?status=${status}`);
};

export const updateTransactionRiskAlert = (id, payload) => {
  return instance.patch(`/transaction/risk-alerts/${id}`, payload);
};

export const getAccountDetails = (id) => {
  return instance.get(`/account/${id}/details`);
};

export const updateSettlementAmount = (transactionId, payload) => {
  return instance.put(`/super-merchant/settlement-amount/${transactionId}`, payload);
};

export const getSettlementConfig = () => {
  return instance.get('/supermerchants/settlementconfig');
};

export const createSettlement = (supermerchantId, payload) => {
  return instance.post(`/supermerchants/${supermerchantId}/settlement`, payload);
};
